import './edit-report-screen.scss'

import _ from 'lodash'
import { noop, set } from 'lodash'
import { EMPTY, of } from 'rxjs'
import { catchError, first, switchMap, tap } from 'rxjs/operators'
import { faCaretDown, faCaretRight, faSave } from '@fortawesome/free-solid-svg-icons'
import { BAlert } from 'bootstrap-vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import { Work, Expression, Manifestation, Item, SearchFeatured, ReportFeatured, ConditionReport, Alteration, Wemi, Signer, createTranslatedString, ConditionReportState, removeRefsInAssociatedMedias, CounterSignatureResource, getTranslatedString, SignerResource, convertSignerToCounterSigner, CounterSignerResource, computeAlterationsIndexes } from '@skinsoft/types'
import { conditionReportSelectors, expressionSelectors, itemSelectors, manifestationSelectors, mediaSelectors } from '@skinsoft/selectors'
import { firstMedia, medias, referenceNumber } from '@skinsoft/selectors/condition-report-selectors'
import {
    ConditionReportDataStore,
    ExpressionDataStore,
    ItemDataStore,
    ManifestationDataStore,
    MediaDataStore,
    WorkDataStore,
} from '@skinsoft/entity'
import { toReportFeatured$ } from '@skinsoft/entity-ui'
import { ConditionReportPDFTransferHelper, ImageTransferHelper, MediaTransferHelper } from '@skinsoft/media-transfer-helper'

import { ReactiveVue } from '@skinsoft/reactive-vue'
import { toSearchFeatured$ } from '@skinsoft/search-data-store/src/featured'
import { FieldStatus, Form, HeaderSearchFeaturedCard } from '@skinsoft/ui'
import { CollapsibleSection } from '@skinsoft/ui/src/collapsible-section'

import { ADD_COUNTER_SIGNATURE, ADD_SIGNER, CLOSE_CLOSE_REPORT_SCREEN_TOPIC, CLOSE_COUNTER_SIGNATURE_MODULE_TOPIC, CLOSE_DRAWING_EDITOR_TOPIC, CLOSE_PDF_OVERVIEW_TOPIC, CLOSE_SIGNATURE_MODULE_TOPIC, COUNTER_SIGNATURE_UPDATED, DELETE_CURRENT_REPORT_TOPIC, DELETE_UNSYNCHRONIZED_MODIFICATIONS_CR_TOPIC, DUPLICATE_CLOSED_REPORT_TOPIC, OPEN_CLOSE_REPORT_SCREEN_TOPIC, OPEN_COUNTER_SIGNATURE_MODULE_TOPIC, OPEN_DRAWING_EDITOR_TOPIC, OPEN_PDF_OVERVIEW_TOPIC, OPEN_SIGNATURE_MODULE_TOPIC, REMOVE_COUNTER_SIGNATURE, REMOVE_SIGNER, REPORT_EDITOR_CLOSE_ALL_TABS_TOPIC, REPORT_EDITOR_OPEN_ALL_TABS_TOPIC, SAVE_CONTRE_SIGNED_REPORT, SAVE_CURRENT_REPORT_TOPIC, SIGNER_UPDATED } from '../../../busTopics'
import { Routes, router } from '../../../router'
import { CloseReportScreen } from '../../component/close-report-screen'
import { SignatureModuleScreen } from '../../component/signature-module/signature-module-screen'
import { PDFOverviewScreen } from '../../pdf-overview-screen'
import { AlertContainer } from '../alert-container'
import { CollapsibleHeader } from '../collapsible-header'
import { DrawingEditor } from '../drawing-editor-components/drawing-editor'
import { SummaryArea } from '../summary-area'
import { AddMediaEvent } from '@skinsoft/entity-ui/src/media/medias-fields-area'
import { Message } from '@skinsoft/bus'
import { DELETE_IMAGE_CLICK_TOPIC, DISPLAY_ALERT_TOPIC, MEDIA_ID_CHANGED_FROM_CACHE, PRINCIPAL_IMAGE_CLICK_TOPIC } from '@skinsoft/bus/src/busTopics'
import { SELECTED_TAB_CHANGE_EVENT, TabsMenu } from '@skinsoft/ui/src/tabs-menu'
import IdentifierAndContext from '../fields-areas/indentifiers-and-context'
import AlterationArea from '../alteration-area'
import { DeleteImageClickEvent } from '@skinsoft/entity-ui/src/media/medias-area'
import { MediaIdChangedFromCacheEvent } from '@skinsoft/ui/src/item-card/media'
import { ALTERATION_EDITED, AlterationChanged, DELETE_ALTERATION } from '../drawing-editor-components/alteration-line'
import { ALTERATION_CREATED } from '../alteration-area/create-alteration-form'
import { ALTERATION_CARD_ALTERATION_UPDATED, ALTERATION_CARD_DELETE_ALTERATION } from '../alteration-area/alteration-card'
import { CounterSignatureModuleScreen } from '../../component/signature-module/counter-signature-module-screen'
import { ConditionReportPDFGenerator } from '@skinsoft/pdf-generator/condition-report-pdf-generator'

declare const DISABLED_FIELDS: { fieldName: string, message?: string, offlineOnly: boolean }[]

@Component({
    components: {
        sAlertContainer: AlertContainer,
        sCloseReportScreen: CloseReportScreen,
        sCollapsibleHeader: CollapsibleHeader,
        sCollapsibleSection: CollapsibleSection,
        sDrawingEditor: DrawingEditor,
        sHeaderSearchFeaturedCard: HeaderSearchFeaturedCard,
        sPdfOverviewScreen: PDFOverviewScreen,
        sSignatureModuleScreen: SignatureModuleScreen,
        sCounterSignatureModuleScreen: CounterSignatureModuleScreen,
        sTabsMenu: TabsMenu,
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    template: require('./edit-report-screen.html'),
})
export class EditReportScreen extends ReactiveVue {

    get initialValues() {
        return {
            conditionReport: {},
        };
    }
    private get form() {
        return this.$refs.reportForm.form;
    }

    public $refs: {
        errorAlert: BAlert;
        reportForm: Form;
    };

    private readOnly: Boolean

    // Entities ids
    public reportId: string = "";

    // Entities
    public item: Item = null as any;
    public manifestation: Manifestation = null as any;
    public expression: Expression;
    public work: Work = null as any;
    public reportFeatured: ReportFeatured = null as any;
    public searchFeatured: SearchFeatured = null as any;
    public conditionReport: ConditionReport = null as any;
    private mediasWithoutPDF: String[] = []
    private pdfMedias: String[] = []

    // Drawing editor
    public drawingEditorParameters: any = {};

    // Icons
    public caretDownIcon = faCaretDown;
    public caretRightIcon = faCaretRight;
    public saveIcon = faSave;

    public reportTitle: string = "";
    public showDrawingEditor: boolean = false;
    public showPdfOverview: boolean = false;
    public showSignatureModule: boolean = false;
    public showCounterSignatureModule: boolean = false
    public showCloseReportScreen: boolean = false;

    private selectedCounterSignature: CounterSignatureResource | null = null

    public hasItem: boolean = true;

    // Data Stores
    private $itemDataStore: ItemDataStore;
    private $workDataStore: WorkDataStore;
    private $manifestationDataStore: ManifestationDataStore;
    private $conditionReportDataStore: ConditionReportDataStore;
    private $expressionDataStore: ExpressionDataStore;
    private $mediaDataStore: MediaDataStore
    private $imageTransferHelper: ImageTransferHelper
    // Pdf tools
    private $conditionReportPDFTransferHelper: ConditionReportPDFTransferHelper
    private $conditionReportPDFGenerator: ConditionReportPDFGenerator

    private fieldName: string = "conditionReport";

    private saveErrorMessage: string = "";
    private saveSuccessMessage: string = "";
    private inventoryNumberAttributedMessage = ""
    private deleteErrorMessage: string = "";
    private deleteSuccessMessage: string = "";

    private disabledFields = [] as { fieldName: string, message?: string, offlineOnly: boolean }[]
    private sections: {component: Vue.Component, sectionTitle?: string, tabTitle: string, props: any, eventListeners: any}[] = []

    private displayedSectionIndex: number = 0

    private isOnline = window.navigator.onLine

    // used to generate an id for v-for feature (v-bind:key)
    private lastSignerId = 1
    private lastCounterSignatureId = 1

    private SELECTED_TAB_CHANGE_EVENT = SELECTED_TAB_CHANGE_EVENT
    private DELETE_IMAGE_CLICK_TOPIC = DELETE_IMAGE_CLICK_TOPIC
    private MEDIA_ID_CHANGED_FROM_CACHE = MEDIA_ID_CHANGED_FROM_CACHE
    private PRINCIPAL_IMAGE_CLICK_TOPIC = PRINCIPAL_IMAGE_CLICK_TOPIC
    private ALTERATION_CREATED = ALTERATION_CREATED
    private DELETE_ALTERATION = DELETE_ALTERATION
    private ALTERATION_CARD_ALTERATION_UPDATED = ALTERATION_CARD_ALTERATION_UPDATED
    private ADD_SIGNER = ADD_SIGNER
    private REMOVE_SIGNER = REMOVE_SIGNER
    private SIGNER_UPDATED = SIGNER_UPDATED
    private SAVE_CONTRE_SIGNED_REPORT = SAVE_CONTRE_SIGNED_REPORT
    private REMOVE_COUNTER_SIGNATURE = REMOVE_COUNTER_SIGNATURE

    public mounted() {
        this.subscribe()

        this.form.registerField(this.fieldName, noop, {
            data: true,
        });

        // Initializing them here to avoid a VueI18N bug when calling $t in async functions
        this.saveErrorMessage = this.$t("editReportScreen.saveAlert.errorMessage") as string;
        this.saveSuccessMessage = this.$t("editReportScreen.saveAlert.successMessage") as string;
        this.inventoryNumberAttributedMessage = this.$t('editReportScreen.saveAlert.inventoryNumberNotUnique') as string
        this.deleteErrorMessage = this.$t("editReportScreen.deleteAlert.errorMessage") as string;
        this.deleteSuccessMessage = this.$t("editReportScreen.deleteAlert.successMessage") as string;

        this.disabledFields = DISABLED_FIELDS.map(disabledField => {
            if(disabledField.message) {
                disabledField.message = this.$t(disabledField.message) as string
            }

            return disabledField
        })

        // we use event listener's for connectivity status because it enable to have components that updates when the network status changes
        window.addEventListener('online', this.updateConnexionStatus)
        window.addEventListener('offline', this.updateConnexionStatus)

        this.sections = [
            {
                component: IdentifierAndContext,
                props: () => {
                    return {
                        reportFeatured: this.reportFeatured,
                        conditionReport: this.conditionReport,
                        form: this.form,
                        fieldName: this.fieldName,
                        signers: this.signers,
                        readOnly: this.readOnly,
                        getFieldStatus: this.getFieldStatus,
                    }
                },
                eventListeners: () => {
                    return {
                        [ADD_SIGNER]: this.onAddSigner,
                        [REMOVE_SIGNER]: this.onRemoveSigner,
                        [SIGNER_UPDATED]: this.onSignerUpdated,
                    }
                },
                tabTitle: this.$t('editReportScreen.reportIdentifiers.tabTitle') as string,
            },
            {
                component: AlterationArea,
                props: () => {
                    return {
                        associatedMedias: this.mediasWithoutPDF ?? [],
                        alterations: this.conditionReport.conditionReportCS?.alterations ?? [],
                        readOnly: this.readOnly,
                        existingTitles: this.alterationsTitles,
                    }
                },
                eventListeners: () => {
                    const eventListeners = {
                        addMedia: this.onAddMedia,
                        [ALTERATION_EDITED]: this.onAlterationChanged,
                        [DELETE_IMAGE_CLICK_TOPIC]: this.onDeleteMedia,
                        [MEDIA_ID_CHANGED_FROM_CACHE]: this.onMediaIdChangedFromCache,
                        [PRINCIPAL_IMAGE_CLICK_TOPIC]: this.onChangeFirstMedia,
                        [ALTERATION_CREATED]: this.addAlteration,
                        [DELETE_ALTERATION]: this.onDeleteAlteration,
                        [ALTERATION_CARD_ALTERATION_UPDATED]: this.onAlterationChanged,
                        [ALTERATION_CARD_DELETE_ALTERATION]: this.onDeleteAlteration,
                    }

                    return eventListeners
                },
                tabTitle: this.$t('editReportScreen.alterations.tabTitle') as string,
            },
            {
                component: SummaryArea,
                props: () => {
                    return {
                        reportFeatured: this.reportFeatured,
                        form: this.form,
                        fieldName: this.fieldName,
                        readOnly: this.readOnly,
                        signers: this.signers,
                        showSigners: this.readOnly,
                        counterSignatures: this.counterSignatures,
                        showCounterSignatures: this.readOnly,
                    }
                },
                eventListeners: () => {
                    return {
                        [ADD_COUNTER_SIGNATURE]: this.onAddCounterSignature,
                        [COUNTER_SIGNATURE_UPDATED]: this.onCounterSignatureUpdated,
                        [REMOVE_COUNTER_SIGNATURE]: this.onRemoveCounterSignature,
                    }
                },
                tabTitle: this.$t('editReportScreen.observations.tabTitle') as string,
            },
        ]
    }

    // TODO Should be called by superclass but it is not the case => investigate later
    public beforeDestroy() {
        super.beforeDestroy()
    }

    private updateConnexionStatus() {
        this.isOnline = window.navigator.onLine
    }

    public onCollapseAllClick() {
        this.emitOnBus(REPORT_EDITOR_CLOSE_ALL_TABS_TOPIC);
    }

    public onDeployAllClick() {
        this.emitOnBus(REPORT_EDITOR_OPEN_ALL_TABS_TOPIC)
    }

    private setConditionReport(updatedConditionReport: ConditionReport) {
        this.conditionReport = updatedConditionReport
    }

    private setReportFeatured(updatedReportFeatured: ReportFeatured) {
        this.reportFeatured = updatedReportFeatured
    }

    public saveReport() {
        return this.form.submit()
    }

    private filterPDFMedias() {
        if(this.conditionReport?.associatedMedias?.medias) {
            this.$mediaDataStore.fetchMany(this.conditionReport.associatedMedias.medias)
                .subscribe((medias: any) => {
                    if(medias) {
                        if(medias.allData) {
                            const PDF_REGEX = /\.pdf$/

                            const [mediasWithoutPDF, pdfMedias] = _.partition(
                                medias.allData, 
                                media => {
                                    const fileName = mediaSelectors.fileName(media)
                                    if(typeof fileName === "string" || fileName instanceof String) {
                                        if(fileName.trim().match(PDF_REGEX)) {
                                            return false
                                        }
                                    }
                                    return true
                                }
                            )

                            const mediasIdsWithoutPDF = mediasWithoutPDF.map(media => mediaSelectors.id(media))

                            // we make sure that mediasWithoutPDF preserve associated medias order
                            this.mediasWithoutPDF = this.conditionReport.associatedMedias.medias?.filter(mediaId => {
                                return mediasIdsWithoutPDF.includes(mediaId)
                            }) ?? []
                            this.pdfMedias = pdfMedias.map(media => mediaSelectors.id(media))
                        }
                    }
                })
        }
    }

    /**
     * This methods ensure the value submitted are valid and do not contains fields used in reporter but not existing in Tryphon
     */
    public adaptValuesBeforeSubmit(values) {
        if(values.conditionReport.conditionReportCS.signers) {
            for(let signer of _.get(values, 'conditionReport.conditionReportCS.signers', [])) {
                delete signer.id
            }
        }

        if(values.conditionReport.conditionReportCS.counterSignatures) {
            for(let counterSignature of values.conditionReport.conditionReportCS.counterSignatures) {
                if(counterSignature.observationCarriedPresenceOfs) {
                    for(let counterSigner of counterSignature.observationCarriedPresenceOfs) {
                        delete counterSigner.index
                    }
                }
            }
        }
    }

    public onSubmit(values: Record<any, any>) {
        let valuesCopy = _.cloneDeep(values) // to avoid modifying method parameter
        // add fields not handled by form to valuesCopy to be saved
        _.set(valuesCopy, 'conditionReport.conditionReportCS.counterSignatures', this.conditionReport.conditionReportCS?.counterSignatures)

        this.adaptValuesBeforeSubmit(valuesCopy)

        // Fetch report to update to perform some checks
        return this.$conditionReportDataStore.fetchOne(this.conditionReport.id).pipe(
            tap(currentConditionReport => {
                // check if some medias have been deleted by the user
                // this works because cached modifications of reports are fetch even if we are online 
                // and also because the media is saved directly on upload (without onSubmit)
                const deletedMedias: string[] = _.difference(medias(currentConditionReport), medias(this.conditionReport))
                const localDeletedMedias = deletedMedias.filter(mediaId => mediaId.startsWith('local:'))
                for(const mediaId of localDeletedMedias) {
                    this.$imageTransferHelper.deleteImageInCache(mediaId)
                }

                // prevents to set an already attributed identifier in offline mode has we have no 100% safe way of checking for doubles without network
                if(!window.navigator.onLine) {
                    const currentReferenceNumber = referenceNumber(currentConditionReport)
                    _.set(valuesCopy, 'conditionReport.conditionReportCS.referenceNumber', currentReferenceNumber)
                    this.form.change('conditionReport.conditionReportCS.referenceNumber', currentReferenceNumber)
                }
            }),
            switchMap(() => {
                return this.$conditionReportDataStore.update(
                    this.conditionReport.id,
                    valuesCopy.conditionReport)
            }),
            switchMap((updatedConditionReport: ConditionReport) => {
                const alertPayload = {
                    message: this.saveSuccessMessage,
                    variant: "success"
                }
                this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
                this.setConditionReport(updatedConditionReport)
                toReportFeatured$(this.conditionReport, this.$i18n.locale).subscribe(reportFeatured => {
                    this.setReportFeatured(reportFeatured)
                })
                return of(undefined) 
            }),
            catchError(error => {
                let submitErrors: any = {}
                const alertPayload = {
                    message: this.saveErrorMessage,
                    variant: "danger"
                };
                if(error.status) {
                    switch(error.status) {
                        case 409:
                            alertPayload.message = this.inventoryNumberAttributedMessage
                            // to set the error, we must set the path corresponding to the name of the field (see s-field) in submitErrors
                            _.set(submitErrors, 'conditionReport.conditionReportCS.referenceNumber', this.$t('editItemScreen.errorMessages.inventoryNumberNotUnique'))
                            break;
                    }
                }

                this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
                return of(submitErrors)
            }),
            first(),
        )
        .toPromise()
    }

    @Watch('conditionReport', { deep: true })
    public onConditionReportChange(conditionReport) {

        // the mutator setFieldData is not working so we hack
        set(this.form.getState().values, 'conditionReport', conditionReport)

        this.form.mutators.setFieldTouched('conditionReport');

        this.filterPDFMedias()
    }

    private get wemi(): Wemi {
        return {
            expression: this.expression,
            item: this.item,
            manifestation: this.manifestation,
            work: this.work,
        } as Wemi
    }

    private get tabsTitles() {
        return this.sections.map(section => section.tabTitle)
    }

    private get fadeInMainContentClasses() {
        return {
            'drawing-editor': this.showDrawingEditor
        }
    }

    private get additionnalEditReportScreenClasses() {
        return this.fadeInMainContentClasses
    }

    private get reportStatus() {
        if(this.reportFeatured.state) {
            return `state.${this.reportFeatured.state}`
        }
        return undefined
    }

    private get contentHidden(): boolean {
        return this.showDrawingEditor || 
            this.showPdfOverview || 
            this.showSignatureModule || 
            this.showCloseReportScreen ||
            this.showCounterSignatureModule
    }

    private isHiddenSection(index) {
        return index !== this.displayedSectionIndex
    }

    public get alterationsTitles(): string[] {
        if(this.conditionReport?.conditionReportCS?.alterations) {
            return _.uniq(
                this.conditionReport.conditionReportCS.alterations
                    .filter(alteration => {
                        if(!alteration.title?.translatedString) {
                            return false
                        }
                        if(!alteration.title.translatedString[this.$i18n.locale]) {
                            return false
                        }
                        return true
                    })
                    .map(alteration => {
                        return (getTranslatedString(alteration.title, this.$i18n.locale) ?? '') as string
                    })
            )
            .sort((title1, title2) => {
                return title1.localeCompare(title2)
            })
        }

        return []
    }

    public get signers() {
        if (!this.conditionReport.conditionReportCS?.signers) {
            _.set(this.conditionReport, 'conditionReportCS.signers', [])
        }
        return this.conditionReport.conditionReportCS!.signers
    }

    public onAddSigner() {
        const blankSigner: Signer = {
            id: this.lastSignerId.toString(),
            signer: createTranslatedString(this.$i18n.locale, ""),
            signature: undefined,
            positionOfSignatory: undefined,
            dateOfSignature: undefined,
        }
        this.lastSignerId++

        if(this.conditionReport?.conditionReportCS?.signers) {
            this.conditionReport.conditionReportCS.signers.push(blankSigner)
        } else {
            set(this.conditionReport, 'conditionReportCS.signers', blankSigner)
        }
    }
    
    public onRemoveSigner(index: number) {
        this.conditionReport?.conditionReportCS?.signers?.splice(index, 1)
    }
    
    public onSignerUpdated([updatedSigner, index]: [Signer, number]) {
        if(this.conditionReport?.conditionReportCS?.signers) {
            this.$set(this.conditionReport.conditionReportCS.signers, index, updatedSigner)
        }
    }
    
    public get counterSignatures() {
        if (!this.conditionReport.conditionReportCS?.counterSignatures) {
            _.set(this.conditionReport, 'conditionReportCS.counterSignatures', [])
        }
        return this.conditionReport.conditionReportCS!.counterSignatures
    }

    private onCounterSignatureUpdated([updatedSignature, index]: [CounterSignatureResource, number]) {
        if(this.conditionReport?.conditionReportCS?.counterSignatures) {
            const indexInArray = this.conditionReport.conditionReportCS.counterSignatures.findIndex(signature => {
                return signature.index === index
            })
            if(indexInArray > -1) {
                this.conditionReport.conditionReportCS.counterSignatures.splice(indexInArray, 1, updatedSignature)
            }
        }
    }

    private onRemoveCounterSignature(index: number) {
        if(this.conditionReport?.conditionReportCS?.counterSignatures?.length) {
            const indexInArray = this.conditionReport.conditionReportCS.counterSignatures.findIndex(signature => {
                return signature.index === index
            })
            if(indexInArray > -1) {
                this.conditionReport.conditionReportCS.counterSignatures.splice(indexInArray, 1)
            }
        }
    }

    private onAddCounterSignature() {
        const blankCounterSignature: CounterSignatureResource = {
            index: this.lastCounterSignatureId,
            comment: createTranslatedString(this.$i18n.locale, ""),
            location: createTranslatedString(this.$i18n.locale, ""),
            reason: undefined,
            date: undefined,
            observationCarriedPresenceOfs: [],
        }
        this.lastCounterSignatureId++

        if(this.conditionReport?.conditionReportCS?.counterSignatures) {
            this.conditionReport.conditionReportCS.counterSignatures.push(blankCounterSignature)
        } else {
            set(this.conditionReport, 'conditionReportCS.counterSignatures', blankCounterSignature)
        }
    }

    private addCounterSignatureWithOriginalSigners() {
        const originalSigners: SignerResource[] = this.conditionReport?.conditionReportCS?.signers ?? []

        const defaultCounterSigners: CounterSignerResource[] = originalSigners.map((signer, index) => {
            let counterSigner = convertSignerToCounterSigner(signer)
            counterSigner.index = index + 1
            return counterSigner
        })

        const blankCounterSignature: CounterSignatureResource = {
            index: this.lastCounterSignatureId,
            comment: createTranslatedString(this.$i18n.locale, ""),
            location: createTranslatedString(this.$i18n.locale, ""),
            reason: undefined,
            date: undefined,
            observationCarriedPresenceOfs: defaultCounterSigners,
        }

        this.lastCounterSignatureId++

        if(this.conditionReport?.conditionReportCS?.counterSignatures) {
            this.conditionReport.conditionReportCS.counterSignatures.push(blankCounterSignature)
        } else {
            set(this.conditionReport, 'conditionReportCS.counterSignatures', blankCounterSignature)
        }
    }

    private onOpenCounterSignatureModule() {
        this.addCounterSignatureWithOriginalSigners()
        this.selectedCounterSignature = this.conditionReport.conditionReportCS?.counterSignatures?.find(cs => {
            return cs.index === this.lastCounterSignatureId - 1
        }) ?? null
    }

    private async saveReportAfterCounterSignature(updateSignatureEvent: [CounterSignatureResource, number]) {  
        this.onCounterSignatureUpdated(updateSignatureEvent)
        await this.saveReport()
        // génération du PDF 
        if(window.navigator.onLine) {
            // alert that we are generating the pdf
            this.$conditionReportPDFGenerator.generatePDF(
                this.conditionReport, 
                this.wemi, 
                async (blob) => {
    
                    const fileName = referenceNumber(this.conditionReport) ? `${referenceNumber(this.conditionReport)}.pdf` : `${MediaTransferHelper.generateMediaHash()}.pdf`
                    const withName = new File([blob], fileName)
        
                    this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                        message: this.$t('editReportScreen.pdf.counterSignaturePDF.startGenerating'),
                        variant: "info"
                    })
                    this.$conditionReportPDFTransferHelper.uploadPDFDocument("application/pdf", this.conditionReport.id, withName, true)
                        .subscribe(async (mediaId: string) => {
                            if(mediaId) {
                                try {
                                    await this.$conditionReportDataStore.addPDFToReport(
                                        conditionReportSelectors.id(this.conditionReport), 
                                        mediaId,
                                    ).toPromise()
                                    this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                                        message: this.$t('editReportScreen.pdf.counterSignaturePDF.success'),
                                        variant: "success"
                                    })
                                } catch (err) {
                                    // Failed to add PDF to report
                                    this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                                        message: this.$t('editReportScreen.pdf.counterSignaturePDF.failure'),
                                        variant: "warning"
                                    })
                                }
                            } else {
                                // Failed to upload report
                                this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                                    message: this.$t('editReportScreen.pdf.counterSignaturePDF.failure'),
                                    variant: "warning"
                                })
                            }
                        })
                },
                this.$i18n.locale,
                this.pdfMedias as string[]
            )
            .catch(e => {
                // Failed to generate PDF
                const alertPayload = {
                    message: this.$t('pdfDocument.generationFailureAlert'),
                    variant: 'danger'
                };
                this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
            })
        } else {
            // alert
            // add a field generate report in condition-report before saving in cache
        }
    }

    public get associatedMediasFieldName() {
        return `${this.fieldName}.associatedMedias`
    }


    public onAddMedia(image: AddMediaEvent) {
        this.$conditionReportDataStore.fetchOne(this.conditionReport.id).pipe(
            first(),
        ).subscribe(conditionReportWithoutModifications => {
            const medias = this.conditionReport.associatedMedias.medias ?? []
    
            if(image.newMediaId) {
                if(medias === null){
                    this.conditionReport.associatedMedias.medias = [image.newMediaId]
                    this.mediasWithoutPDF = [image.newMediaId]
                } else{
                    this.conditionReport.associatedMedias.medias = medias.filter(id => id !== image.cacheKey)
                    this.conditionReport.associatedMedias.medias.push(image.newMediaId)

                    this.mediasWithoutPDF = this.mediasWithoutPDF.filter(id => id !== image.cacheKey)
                    this.mediasWithoutPDF.push(image.newMediaId)
                }
            } 
            else if(medias === null) {
                this.conditionReport.associatedMedias.medias = [image.cacheKey]
                this.mediasWithoutPDF = [image.cacheKey]
            } 
            else if(!medias.includes(image.cacheKey)) {
                if(this.conditionReport.associatedMedias?.medias) {
                    this.conditionReport.associatedMedias.medias.push(image.cacheKey)
                } else {
                    _.set(this.conditionReport, 'associatedMedias.medias', [image.cacheKey])
                }
                this.mediasWithoutPDF.push(image.cacheKey)
            }
        })
    }

    private onDeleteMedia(event: DeleteImageClickEvent) {
        const updatedMedias = this.conditionReport.associatedMedias?.medias?.filter(mediaId => {
            return mediaId !== event.imageId
        })
        _.set(this.conditionReport, 'associatedMedias.medias', updatedMedias)

        this.mediasWithoutPDF = this.mediasWithoutPDF.filter(mediaId => mediaId !== event.imageId)
        
        const principalMedia = firstMedia(this.conditionReport)
        if(principalMedia === event.imageId) {
            _.set(this.conditionReport, "associatedMedias.first", null)
        }
    }

    private onChangeFirstMedia(mediaId: string) {
        const medias: string[] = _.get(this.conditionReport, "associatedMedias.medias", [])
        if(medias && medias.includes(mediaId)) {
            _.set(this.conditionReport, "associatedMedias.first", mediaId)
        }
    }

    private onMediaIdChangedFromCache(event: MediaIdChangedFromCacheEvent) {
        let index = this.conditionReport.associatedMedias?.medias?.indexOf(event.oldMediaId)
        if(index) {
            this.conditionReport.associatedMedias!.medias!.splice(index, 1, event.newMediaId)

            const principalMedia = firstMedia(this.conditionReport)
            if(principalMedia === event.oldMediaId) {
                _.set(this.conditionReport, "associatedMedias.first", event.newMediaId)
            }

            // inside the if because if the media is not in conditionreport.associatedMedia, it is not in mediasWithoutPDF
            index = this.mediasWithoutPDF.indexOf(event.oldMediaId)
            if(index) {
                Vue.set(this.mediasWithoutPDF, index, event.newMediaId)
            }
        }
    }

    private onSelectedTabChanged(selectedTab: number) {
        this.displayedSectionIndex = selectedTab
    }

    private onAlterationChanged(event: AlterationChanged) {
        const oldValue = this.conditionReport.conditionReportCS?.alterations?.[event.alterationNumber]
        if(oldValue) {
            this.conditionReport.conditionReportCS!.alterations![event.alterationNumber] = _.merge(oldValue, event.updates)
        } else {
            _.set(this.conditionReport, 'conditionReportCS.alterations', [event.updates])
        }

        this.reNumberAlterations()
    }

    private onDeleteAlteration(index: number) {
        this.conditionReport.conditionReportCS?.alterations?.splice(index, 1)
        this.reNumberAlterations()
    }

    private addAlteration(alteration: Alteration) {
        if(this.conditionReport.conditionReportCS?.alterations) {
            this.conditionReport.conditionReportCS.alterations.push(alteration)
        } else {
            _.set(this.conditionReport, 'conditionReportCS.alterations', [alteration])
        }

        this.reNumberAlterations()
    }

    private reNumberAlterations() {
        if(this.conditionReport?.conditionReportCS?.alterations?.length) {
            const renumberedAlterations = computeAlterationsIndexes(this.conditionReport)
            this.conditionReport.conditionReportCS.alterations = renumberedAlterations
        }
    }

    private openDrawingEditor(mediaId?: string, dataUrl?: string) {
        this.reNumberAlterations()

        this.drawingEditorParameters = {
            mediaId: mediaId,
            mediaUrl: dataUrl,
            mediaAlterations: this.conditionReport.conditionReportCS?.alterations?.filter(
                alterations => {
                    return alterations.media === mediaId
                }
            ) ?? [],
        }
        this.drawingEditorParameters.firstAlterationIndex = this.drawingEditorParameters.mediaAlterations?.[0]?.index
        this.showPdfOverview = false;
        this.showDrawingEditor = true
    }

    private async onOpenDrawingEditor(message: Message) {
        if (message.payload) {
            const mediaId = message.payload
            
            if(MediaTransferHelper.isLocalMedia(mediaId)) {
                this.$imageTransferHelper.downloadImageOffline(mediaId).subscribe(res => {
                    if(res.dataUrl) {
                        this.openDrawingEditor(mediaId, res.dataUrl)
                    }
                })
            } else {
                // check if mediaId is present in associatedMedias prevents losing image when closing drawing editor
                // also prevents bugs with image becoming blank after editing on drawing editor
                const medias = this.conditionReport.associatedMedias.medias
                if(medias && medias.includes(mediaId)) {
                    this.openDrawingEditor(mediaId)
                }
            }
        }
    }

    private async onDrawingEditorClosed(message: Message) {
        if (message.payload) {
            const updatedAlterations: Alteration[] = message.payload.newData
            const mediaId = message.payload.alterationMediaId ?? updatedAlterations?.[0]?.media

            if(message.payload.saveReport && mediaId) {
                if (updatedAlterations && updatedAlterations.length) {
                    // we remove the alterations that will be updated from the list of alterations
                    let alterationsWithoutUpdatedOnes = this.conditionReport.conditionReportCS?.alterations?.filter(
                        alteration => {
                            if(alteration.media === mediaId) {
                                return false
                            }
                            return true
                        }
                    ) ?? []
                    
                    _.set(
                        this.conditionReport, 
                        'conditionReportCS.alterations', 
                        alterationsWithoutUpdatedOnes.concat(updatedAlterations)
                    )
                } else {
                    // if there is no more alteration, then its a deletion
                    if(this.conditionReport.conditionReportCS?.alterations?.length) {
                        this.conditionReport.conditionReportCS.alterations = this.conditionReport.conditionReportCS.alterations.filter(
                            alteration => {
                                if(alteration.media === mediaId) {
                                    return false
                                }
                                return true
                            }
                        )
                    }
                }
                
                this.showDrawingEditor = false
                await this.saveReport()
            }
        }
        this.showDrawingEditor = false
    }

    private deleteCurrentReport() {
        const deletePromise = this.$conditionReportDataStore.delete(this.conditionReport.id).pipe(first()).toPromise()
        if (deletePromise) {
            deletePromise
                .then((response: any) => {
                    const alertPayload = {
                        message: this.deleteSuccessMessage,
                        variant: "success"
                    };
                    this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
                })
                .catch(e => {

                    const alertPayload = {
                        message: this.deleteErrorMessage,
                        variant: "danger"
                    };
                    this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
                })
        }
    }

    private deleteModificationsNotSynchronized() {
        if(this.conditionReport.associatedMedias?.medias) {
            for(const mediaId of this.conditionReport.associatedMedias.medias) {
                if(MediaTransferHelper.isLocalMedia(mediaId)) {
                    ImageTransferHelper.getInstance().deleteImageInCache(mediaId)
                }
            }
        }
        this.$conditionReportDataStore.removeObjectFromUpdateCache(this.conditionReport.id)
            .then(() => {
                this.subscribe()
                this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                    message: this.$t('editReportScreen.deleteModificationsNotification.successMessage'),
                    variant: "success"
                });
            })
            .catch((err) => {
                this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                    message: this.$t('editReportScreen.deleteModificationsNotification.errorMessage'),
                    variant: "danger"
                });
            })
    }

    private async duplicateReportIfClosed() {
        if(conditionReportSelectors.status(this.conditionReport) === ConditionReportState.CLOSED) {
            let body: ConditionReport = this.conditionReport
            
            const pdfIds = _.get(this.conditionReport, 'associatedMedias.medias', [])
            .filter(mediaId => !this.mediasWithoutPDF.includes(mediaId))
            
            if(pdfIds) {
                body = _.cloneDeep(this.conditionReport)
                const associatedMediasWithoutPDF = removeRefsInAssociatedMedias(body.associatedMedias, pdfIds)
                _.set(body, "associatedMedias", associatedMediasWithoutPDF)
            }
            
            // Not usefull yet (because adapt value before submit only handle signers, that we don't keep in duplicated report), 
            // but it might be necessary if adaptValuesBeforeSubmit handle more fields
            // this.adaptValuesBeforeSubmit(body)

            this.$conditionReportDataStore.duplicate(this.conditionReport.id, undefined, body).pipe(
                catchError(error => {
                    // logger
                    this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                        message: this.$t('editReportScreen.alerts.duplicateClosedReport.failure'),
                        variant: "danger"
                    })
                    return of(error)
                }),
            ).subscribe(createdReport => {
                router.push({
                    name: Routes.EDIT_REPORT,
                    params: {
                        reportId: createdReport.id
                    },
                })

                this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                    message: this.$t('editReportScreen.alerts.duplicateClosedReport.success'),
                    variant: "success"
                })
            })
        } else {
            this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                message: this.$t('editReportScreen.alerts.duplicateClosedReport.warningReportNotClosed'),
                variant: "danger"
            })
        }
    }

    private subscribe() {
        this.reportId = this.$route.params.reportId;

        // Retrieving data for collapsible header
        this.subscribeTo(this.$conditionReportDataStore.fetchOne(this.reportId)
            .pipe(
                // saving condition report object
                tap(conditionReport => {
                    this.conditionReport = conditionReport
                    if(!this.conditionReport.associatedMedias) {
                        _.set(this.conditionReport, 'associatedMedias', {
                            medias: [],
                            first: undefined,
                            second: undefined,
                            third: undefined
                        })
                    }
                }),
                switchMap((report) => toReportFeatured$(report, this.$i18n.locale)),
                // Retrieving one by one M, E, W to rebuild a searchFeatured
                switchMap(
                    (reportFeatured) => {
                        this.reportFeatured = reportFeatured
                        if (this.reportFeatured.involvedItem) {
                            return this.$itemDataStore.fetchOne(this.reportFeatured.involvedItem)
                        }
                        else {
                            // If no item is attached to report, stopping the rquest chain here
                            this.hasItem = false;
                            return EMPTY
                        }
                    }
                ),
                switchMap(
                    (item) => {
                        this.item = item;
                        return this.$manifestationDataStore.fetchOne(itemSelectors.manifestation(item))
                    }
                ),
                switchMap(
                    (manifestation) => {
                        this.manifestation = manifestation;
                        return this.$expressionDataStore.fetchOne(manifestationSelectors.expression(manifestation))
                    }
                ),
                switchMap(
                    (expression) => {
                        this.expression = expression;
                        const workId = expressionSelectors.work(expression);
                        if (workId) {
                            return this.$workDataStore.fetchOne(workId)
                        } else {
                            return of(null)
                        }

                    }
                ),
                switchMap(
                    (work) => {
                        // Combining I, M, W to rebuild a searchFeatured used in the header
                        if (work) {
                            this.work = work;
                        }
                        return toSearchFeatured$(
                            this.wemi,
                            this.$i18n.locale,
                            false
                        )
                    }
                )
            ),
            (searchFeatured) => {
                this.searchFeatured = searchFeatured;
            },
            "search-featured-retrieval-chain"
        )

        // Filtering PDF medias
        this.filterPDFMedias()

        // Subscribe to save event
        this.subscribeToBus(SAVE_CURRENT_REPORT_TOPIC, () => {
            this.saveReport()
        },
            'save-report-subscription')

        this.subscribeToBus(DELETE_CURRENT_REPORT_TOPIC, () => {
            this.deleteCurrentReport()
        },
            'delete-report-subscription')

        this.subscribeToBus(DELETE_UNSYNCHRONIZED_MODIFICATIONS_CR_TOPIC, () => {
            this.deleteModificationsNotSynchronized()
        })

        // Subscribe to annotation events to open drawing editor when needed
        this.subscribeToBus(OPEN_DRAWING_EDITOR_TOPIC, this.onOpenDrawingEditor)

        this.subscribeToBus(CLOSE_DRAWING_EDITOR_TOPIC, this.onDrawingEditorClosed)

        // Events to open/close pdf overview screen

        this.subscribeToBus(OPEN_PDF_OVERVIEW_TOPIC, (message) => {
            this.showDrawingEditor = false
            this.showCloseReportScreen = false;
            this.showSignatureModule = false
            this.showPdfOverview = true;
            this.showCounterSignatureModule = false
        })

        this.subscribeToBus(CLOSE_PDF_OVERVIEW_TOPIC, (message) => {
            this.showPdfOverview = false;
        })

        this.subscribeToBus(OPEN_SIGNATURE_MODULE_TOPIC, (message) => {
            this.showDrawingEditor = false
            this.showPdfOverview = false;
            this.showCloseReportScreen = false;
            this.showSignatureModule = true;
        })

        this.subscribeToBus(CLOSE_SIGNATURE_MODULE_TOPIC, (message) => {
            this.showSignatureModule = false;

        })

        this.subscribeToBus(OPEN_COUNTER_SIGNATURE_MODULE_TOPIC, (message) => {
            this.showDrawingEditor = false
            this.showPdfOverview = false;
            this.showCloseReportScreen = false;
            this.showSignatureModule = false;
            
            this.onOpenCounterSignatureModule()
            this.showCounterSignatureModule = true
        })

        this.subscribeToBus(CLOSE_COUNTER_SIGNATURE_MODULE_TOPIC, (message) => {
            this.showCounterSignatureModule = false
        })

        this.subscribeToBus(OPEN_CLOSE_REPORT_SCREEN_TOPIC, async (message) => {
            await this.saveReport()
            this.showDrawingEditor = false
            this.showCloseReportScreen = true;
            this.showSignatureModule = false;
            this.showCounterSignatureModule = false
        })

        this.subscribeToBus(CLOSE_CLOSE_REPORT_SCREEN_TOPIC, (message) => {
            this.showCloseReportScreen = false;
        })

        this.subscribeToBus(DUPLICATE_CLOSED_REPORT_TOPIC, (message) => {
            this.duplicateReportIfClosed()
        })

    }

    private getFieldStatus(fieldName: string) {
        let result: FieldStatus = {
            disabled: false
        }
        
        const disabledField = this.disabledFields?.find(disabledField => {
            return disabledField.fieldName === fieldName
        })

        if(disabledField) {
            if(!disabledField.offlineOnly || !this.isOnline) {
                result.disabled = true
                if(disabledField.message) {
                    result.disabledMessage = disabledField.message
                }
            }
        }

        return result
    }

    private unsubscribe() {
        this.unsubscribeFrom('search-featured-retrieval-chain');
        this.unsubscribeFrom('save-report-subscription');
        this.unsubscribeFrom('delete-report-subscription');
    }

    @Watch('reportFeatured')
    private buildTitle() {
        if (this.reportFeatured) {
            this.reportTitle = this.$t('editReportScreen.reportTitlePrefix', {
                refNumber: this.reportFeatured.referenceNumber,
            }) as string;
        }
    }

}
